import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { UserAuthService } from './../../services/user-auth.service';

import { UsersModel, User} from './../../models/users.model';

const URL = '/api/';

@Component({
  selector: 'app-modal-user',
  templateUrl: './modal-user.component.html',
  styles: []
})

export class ModalUserComponent implements OnInit {
  user : User;
  formControl = new FormControl('');
  modalForm : FormGroup;
  private _userModel = new UsersModel;
  selectedFile : File;
  message:any;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private router: Router, private http: HttpClient, private userService: UserAuthService) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.user ? this.user.clave : null],
      nombre: [this.user ? this.user.nombre : null],
      correo: [this.user ? this.user.correo : null],
      password: [this.user ? this.user.password : null],
      rol: [this.user ? this.user.rol : null],
      imagen: [this.user ? this.user.imagen : ""],
    });
  }

  onFileSelected(event){
    this.selectedFile = event.target.files[0];
  }

  //Agregar dominio
  adminUser(){
    this.activeModal.close('Guardado datos');
    if(this.selectedFile)
    {
      this._userModel.uploadImageProfile(this.selectedFile, '/users/', this.selectedFile.name).then(val => {
        var ruta = val;
        this._userModel.createUser(this.modalForm.value, ruta).then(result => {
          if(result.data.errorInfo)
            alert("Usuario no modificado - razon: " + result.data.errorInfo.message);
          this.message = result;
        }).catch(error => {
          console.log(error);
        });
      });
    }
    else
    {
      this._userModel.createUser(this.modalForm.value, "").then(result => {
        if(result.data.errorInfo)
          alert("Usuario no creado - razon: " + result.data.errorInfo.message);
        this.message = result;
      }).catch(error => {
        console.log(error);
      });
    }
  }

}
